import { Component, ChangeDetectionStrategy, inject } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { filter } from 'rxjs/operators';
import { Platform, IonApp, IonMenu, IonRouterOutlet } from '@ionic/angular';

declare const hj: Function;
import { StorageService } from './services/storage.service';
import { AuthService } from './services/auth.service';
import { Session } from './models/session.model';
import { BrandingService } from './services/branding.service';
import { Subscription } from 'rxjs';

import { SidebarComponent } from './components/sidebar/sidebar.component';
import { SafePipe } from './pipes/safe.pipe';

@Component({
    selector: 'app-root',
    templateUrl: 'app.component.html',
    styleUrls: ['app.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [IonApp, IonMenu, IonRouterOutlet, SidebarComponent, SafePipe]
})
export class AppComponent {
  private router = inject(Router);
  private platform = inject(Platform);
  private storage = inject(StorageService);
  auth = inject(AuthService);
  private brandingService = inject(BrandingService);

  url: string = '';
  fontUrlSubscription: Subscription;

  mirror: boolean = false;
	mirrorToken?: string;

  constructor() {
    this.router.events
      .pipe(filter(event => event instanceof NavigationEnd))
      .subscribe((event) => {
        if (typeof hj !== 'undefined') {
          hj('stateChange', (event as NavigationEnd).urlAfterRedirects);
        }
      });
    this.initApp();
  }

  initApp() {
    this.platform.ready().then(() => {

      const tokenParam = this.platform.getQueryParam('token');
      const currentUrl = this.router.url;
      
      if(tokenParam && !currentUrl.includes('/mirror')) {
				// MIRROR FUNCTIONALITY IS ON - redirect to mirror page
				this.mirror = true;
				this.mirrorToken = tokenParam;
			}

      this.storage.init().then(() => {
        this.fontUrlSubscription = this.brandingService.fontUrl.subscribe(async font => {
          //console.log('Change font?', font);
          this.url = font;
        });
        this.detectAutoLogin();
      });
    });
  }

  /*  async checkSession(){
     await this.auth.checkSession().then(async (data: any) => {
       if (data.ok){
         this.detectAutoLogin();
       }
     });
   } */

  async detectAutoLogin() {
    if (this.isValidUrl()) {
      if(!this.mirror) { // NO MIRROR FUNCTIONALITY --> STUDENT LOGS IN
        this.auth.getCredentials().then(async (data: Session) => {
          if (data != null) {
            if (data.userData['c_status'] == 'P' || data.userData['c_status'] == 'V') {
              return;
            }
            if (data.userData['c_status'] == 'R') {
              this.navigate('/confirm-account');
            }
            else if (data.userData['c_status'] == 'FL') {
              this.navigate('/first-login-info');
            }
            //else {
            //  //console.log("App component: Session DETECTED, redirect to Main Page.");
            //  data.userData['id_institution'] ? this.navigate('/degree-progress') : this.navigate('/planning');
            //}
          } else {
            //console.log("App component: No session detected, redirect to Intro.");
            this.navigate('/intro')
          }
        })
      } else { 
        // MIRROR FUNCTIONALITY - Redirect to mirror page with token
        this.router.navigate(['/mirror'], { queryParams: { token: this.mirrorToken } });
      }
    }
  }

  isValidUrl(): boolean {
    let pages: string[] = ['register', 'register/confirmed', 'recovery', 'confirm', 'delete-account', 'terms-and-conditions', 'mirror'];
    const initialUrl = this.router.currentNavigation()?.initialUrl;
    const path = initialUrl?.root?.children['primary']?.segments[0]?.path;
    return !pages.includes(path);
  }

  navigate(url: string) {
    //console.log(`App component: Redirect to ${url}`);
    this.router.navigate([url]);
  }

  logOut() {
    this.storage.clear();
    this.auth.logOut();
    this.navigate('/intro');
  }

}
